<template>
    <div class="flex" :style="`width: ${width}px;${rootstyle||''}`">
        <div v-if="!item.hide" v-for="(item,index) in columns" class="flex" :key="index" :style="'min-width: '+item.width+'px;color: #aaa;padding-right: 10px;'">
            <div>
                <div>{{item.title}}</div>
                <div v-if="item.label" style="line-height: 1;font-size: 10px;">{{item.label}}</div>
            </div>
            <PageTooltip v-if="item.tip" :content="item.tip" :width="300" :name="''" :placement="'top-start'" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            columns: {
                type: Array,
                default: () => []
            },
            rootstyle: {
                type: String
            }
        },
        data() {
            return { width: 100 }
        },
        mounted() {
            this.updateUI()
        },
        watch: {
            columns() {
                this.updateUI()
            }
        },
        methods: {
            updateUI() {
                this.width = this.columns.sum('width') + 40
            }
        }
    }
</script>

<style scoped>
    .flex {
        display: flex;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/CustomTableColumns.vue?04d7417a